import { RootState } from "store";
import { StateCreator } from "zustand";

import { staticInformation } from "common/consts/staticInformation";
import { FavoriteCustomer } from "models/customers/customers";
import { StaticInformation } from "models/StaticInformation";
import { clearWorkingTabCustomer } from "common/MetaActions";

export interface GlobalSlice {
  workingCustomerId: string;
  favoriteCustomer: FavoriteCustomer | undefined;
  staticInformation: StaticInformation;

  setWorkingCustomerId: (id: string) => void;
  setStaticInformation: () => void;
  setUserFavoriteCustomer: (fav: FavoriteCustomer | undefined) => void;
  resetCustomer: () => void;
}

export const createGlobalSlice: StateCreator<
  RootState,
  [["zustand/devtools", never]],
  [],
  GlobalSlice
> = (set, get) => ({
  workingCustomerId: "",
  favoriteCustomer: undefined,
  staticInformation: staticInformation,

  setWorkingCustomerId: (id) => {
    get().customers.resetWorkingCustomer();

    set(
      ({ global }) => ({
        global: {
          ...global,
          workingCustomerId: id
        }
      }),
      false,
      "global/SET_WORKING_CUSTOMER_ID"
    );
  },

  setStaticInformation: () => {
    const supportContact = staticInformation.supportContactInformation;
    const headOffice = staticInformation.headOfficeAddressInformation;

    const enrichedStaticInformation: StaticInformation = {
      ...staticInformation,
      supportContactInformation: {
        ...supportContact,
        hrefPhone: `tel:${supportContact.phone}`,
        hrefEmail: `mailto:${supportContact.email}`
      },
      headOfficeAddressInformation: {
        ...headOffice,
        hrefPhone: `tel:${headOffice.phone}`,
        hrefEmail: `mailto:${headOffice.email}`
      }
    };

    set(
      ({ global }) => ({
        global: {
          ...global,
          staticInformation: enrichedStaticInformation
        }
      }),
      false,
      "global/SET_STATIC_INFORMATION"
    );
  },

  setUserFavoriteCustomer: (favoriteCustomer) =>
    set(
      ({ global }) => ({
        global: {
          ...global,
          favoriteCustomer
        }
      }),
      false,
      "global/SET_USER_FAVORITE_CUSTOMER"
    ),

  resetCustomer: () => {
    get().global.setWorkingCustomerId("");
    clearWorkingTabCustomer();
    get().inbox.resetInbox();
    get().archive.resetArchive();
  }
});
